<p>autologout works!</p>
